const scrollers = document.querySelectorAll(".scroller");

// Si l'utilisateur n'a pas opté pour une réduction de mouvement, alors nous ajoutons l'animation
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  addAnimation();
}

// Ajout de l'animation
function addAnimation() {
  scrollers.forEach((scroller) => {
    // Ajouter data-animated="true" à chaque élément `.scroller` sur la page
    scroller.setAttribute("data-animated", true);

    // Créer un tableau des éléments à l'intérieur de `.scroller-inner`
    const scrollerInner = scroller.querySelector(".scroller__inner");
    const scrollerContent = Array.from(scrollerInner.children);

    // Pour chaque élément du tableau, le cloner
    // Ajouter aria-hidden
    // Ajouter dans `.scroller-inner`
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  });
}

// Fonction pour ajouter la fonctionnalité de défilement horizontal
function addHorizontalScroll(scroller) {
  let isDragging = false;
  let startX, scrollLeft;

  function dragStart(event) {
    isDragging = true;
    startX = event.pageX - scroller.offsetLeft;
    scrollLeft = scroller.scrollLeft;
  }

  function drag(event) {
    if (!isDragging) return;
    event.preventDefault();
    const x = event.pageX - scroller.offsetLeft;
    const walk = x - startX;
    scroller.scrollLeft = scrollLeft - walk;
  }

  function dragEnd() {
    isDragging = false;
  }

  scroller.addEventListener("mousedown", dragStart);
  scroller.addEventListener("mousemove", drag);
  scroller.addEventListener("mouseup", dragEnd);
  scroller.addEventListener("mouseleave", dragEnd);

  scroller.addEventListener("touchstart", dragStart);
  scroller.addEventListener("touchmove", drag);
  scroller.addEventListener("touchend", dragEnd);
}

// Boucle à travers tous les éléments ".scroller" pour les rendre glissables horizontalement
scrollers.forEach((scroller) => {
  addHorizontalScroll(scroller);
});
